const init = () => {
  if (document.querySelector('.agenda_section')) {
    document.addEventListener('tabby', (event) => {
      const { tab } = event.detail;
      const alternateSelector = tab.dataset.tabsAlternate;
      if (alternateSelector) {
        const alternateTab = document.querySelector(`[href*="${alternateSelector}"]`);
        alternateTab.click();
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', init);
